<template>
  <div id="app" v-cloak>
    <!-- <v-loading :show="loading.show"></v-loading> -->
    <keep-alive :include="keepAlive">
      <router-view v-if="isRouterAlive" />
    </keep-alive>

  </div>
</template>

<script>
// import loading from "@/base/loading/loading.vue";
export default {
  name: "App",
	data() {
		return{
			isRouterAlive: true
		}
	},
	provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。                                             
		return {
			reload: this.reload                                              
		}
	},
  // components: {
  //   "v-loading": loading
  // },

  computed: {
    // loading() {
    //   return {
    //     show: this.$store.getters.isLoading
    //   };
    // },
    keepAlive() {
      return this.$store.getters.getKeepAlive
    }
  },

	methods: {
		reload () {
			this.isRouterAlive = false;            //先关闭，
			this.$nextTick(function () {
				this.isRouterAlive = true;         //再打开
			}) 
		}
	},

};
</script>

<style>
[v-cloak] {
  display: none;
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(50px, 0);
  transform: translate(50px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-50px, 0);
  transform: translate(-50px, 0);
}
::-webkit-scrollbar {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/App.vue